import { useSelector } from "react-redux"
import { getAiSummaryStartDate, getEndDate } from "selectors/dates"
import { createDateAdapter } from "./create-date-adapter"

export const withAiSummaryDates = createDateAdapter(() => ({
  startDate: useSelector(getAiSummaryStartDate),
  endDate: useSelector(getEndDate),
}))
